import React from "react";
//import ReactDOM from "react-dom";
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import "./reset.min.css"; // resetando css
import "./App.css";
import "./Cores.css";
//import api from './services/api';
//import './services/api';
import RequireAuth from './components/RequireAuth';
import RequireADM from './components/RequireADM';

import Login from "./pages/Login";
import Register from "./pages/Register";
// import Modules from "./pages/Modules";
//import Initial from "./pages/Initial";
import Erro404  from "./pages/Pagina404";
// import EsqueceuSenha from "./pages/EsqueceuSenha";
import ResetarSenha from "./pages/auth/ResetarSenha";
import Logout from "./pages/auth/Logout";

import Home from './pages/HomeDj';
import Mundos from "./pages/Mundos";
import {Parabens} from "./pages/Mundos";
//import NovaHomeDj from './pages/NovaHomeDj';
import Vi from './pages/Vi';

//import AssistirAula from "./pages/AssistirAula";
//import Home from './pages/Home';
//import Pagina404 from "./pages/Register";
//import Main from "./pages/Main";
//import Dj from "./pages/Dj";
import NoiteDia from "./components/NoiteDia";
//import SignUp from "./components/SignUp/index";
//const Pagina404 = () => (<div>Página 404</div>)

import useFindUser from './hooks/useFindUser';
import {UserContext} from './hooks/UserContext';

import MBlock from "./pages/MBlock";
import CadastrOkay from "./pages/CadastrOkay";

//import Ranking from "./pages/Ranking";

// import EmManutencao from "./pages/EmManutencao";
import Quiz from "./pages/Dj/Quiz";
import NavBar from "./pages/Dj/NavBar";
import Perguntas from "./pages/Dj/Perguntas";

import Ranking from "./pages/Ranking";
// import Adm from "./pages/Adm";
import Supervisorio from "./pages/Adm/Supervisorio";
import Cadastros from "./pages/Adm/Cadastros";
// import Testes from "./pages/Dj/Testes";
// import MHome from "./pages/Dj/MHomeDj2";

// import Manual from "./pages/Manual";
import Duvidas from "./pages/Duvidas";
import Sobre from './pages/Sobre';
import Musica from './pages/exemplos/Musica';
import Simulador from './pages/Simulador';
import Termos from './pages/Termos';
import Certificados from "./pages/Certificados";
import OFCertificados from "./pages/Certificados/OFCertificado.jsx";
// import Certificados_OF from "./pages/Certificados/__OficinaCertificados.jsx";

import AdmMenu from "./pages/Adm/AdmMenu";

function App() {

  const {user, setUser, isLoading} = useFindUser(); // Para Login

  return (<BrowserRouter>
    <UserContext.Provider value={{ user, setUser, isLoading }}>
      <Routes>
        {/* Debug Menus */}

        {/* //Página inicial */}
        {/* <Route  path = "/" element={Initial} /> */}
        <Route  path={"/"} element={<Home/>}/>
        <Route  path={"/inicio"} element={<Home/>}/>
        <Route  path={"/home"} element={<Home/>}/>

        {/* //Rotas de Autenticação */}
        <Route  path={"/Login"} element={<Login/>}/>
        <Route  path={"/Entrar"} element={<Login/>}/>

        <Route  path={"/Logout"} element={<Logout/>}/>
        <Route  path={"/sair"} element={<Logout/>}/>

        <Route  path="/Cadastrar" element={<Register/>}/>
        <Route  path="/Cadastrar/Okay" element={<CadastrOkay/>}/>
        {/* <Route  path="/Login/Mundo" element={<Modules/>}/> */}
        <Route  path="/EsqueceuSenha" element={<ResetarSenha/>}/>

        {/* // Rotas do usuario comum para assistir as aulas */}
        <Route  path="/Planetas" element={
          <RequireAuth><Mundos/></RequireAuth>
        }/>
        <Route  path="/Planetas/ok" element={
          <RequireAuth><Parabens/></RequireAuth>
        }/>
        <Route path="/Planetas/block/" element={ // tive de duplicar por conta do operador :motivo?
          <RequireAuth><MBlock/></RequireAuth>
        }/>
        <Route path="/Planetas/block/:motivo" element={// tive de duplicar por conta do operador :motivo?
          <RequireAuth><MBlock /></RequireAuth>
        }/>
        <Route  path="/Planetas/:id_mundo/:id_fase" element={
          <RequireAuth><Vi/></RequireAuth>
        }/>

        {/* // Rotas de navegação para informações */}
        <Route  path="/Ranking"   element={<Ranking/>}/>
        <Route  path="/Sobre"     element={<Sobre/>}/>
        <Route  path="/Musica"     element={<Musica/>}/>
        <Route  path="/Duvidas"   element={<Duvidas/>}/>
        <Route  path="/Cadastros" element={<Cadastros/>}/>
        <Route  path="/Termos" element={<Termos/>}/>

        <Route path="/Certificados/" element={ // tive de duplicar por conta do operador :certificado_id?
            <RequireAuth>
              <Certificados/>
            </RequireAuth>
        }/>
        <Route path="/Certificados/:certificado_id" element={ // tive de duplicar por conta do operador :certificado_id?
          <RequireAuth>
            <Certificados/>
          </RequireAuth>
        }/>

        <Route  path="/Certificados/OFC/:certificado_id" element={<OFCertificados/>}/>

        {/* // Rotas do Professor */}
        <Route  path="/Supervisorio" element={<RequireADM children={<Supervisorio/>} patente={2} />}/>

        {/* // Rotas de Administrador */}
        <Route  path="/AdmMenu" element={<RequireADM children={<AdmMenu/>} patente={2} />}/>

        {/* // Rotas de testes do DJ*/}
        {/*
          <Route   path="/NovaHomeDj" element={<NovaHomeDj/>}/>
          <Route  path= "/" children =< {/>Main} />
          <Route  path= "/Login/Home/Modulo/AssistirAula" element={<AssistirAula/>} />
        */}
        <Route  path="/Dj/NoiteDia" element={<RequireADM children={<NoiteDia/>}/> }/>
        <Route  path="/Dj/Quiz" element={<RequireADM children={<Quiz/>}/> }/>
        {/* <ARoute  path="/Dj/Adm" element={<Adm/>}/> */}
        <Route  path="/Dj/NavBar" element={<RequireADM children={<NavBar/>}/> }/>
        <Route  path="/Dj/Perguntas" element={<RequireADM children={<Perguntas/>}/> }/>
        <Route   path="/Dj/Simulador" element={<Simulador/>}/>
        {/* <ARoute  path="/Dj/Testes" element={<Testes/>}/> */}
        {/* <Route  path= "/Dj" element= {Dj} /> */}
        {/* Minha página de testes */}
        {/* <Route  path="/m" element={<MHome/>}/> */}

        {/* páginas de erro */}
        {/* <Route  path="/googlec8afd96e328c5525.html" element={<>google-site-verification: googlec8afd96e328c5525.html</>}/> */}
        <Route element={<Erro404/>}/>
      </Routes>
    </UserContext.Provider>
  </BrowserRouter>)
}

export default App;
